import React, { useState } from 'react'
import { AlertTriangle, Plus, Trash } from 'react-feather';
import { useForm } from 'react-hook-form';
import { InputValidators } from '../../../utils/validators/InputValidators';
import { CardCobroVenta } from '../shared/CardCobroVenta';
import { useSelector } from 'react-redux';

export const SaleSpecial_r = ({ onUpdate }) => {

  const { descuentos, tipos_pagos, servicios, productosAlm, isLoading } = useSelector(state => state.catalogos);
  const { empleados } = useSelector(state => state.empleados);
  const { register, handleSubmit, reset, setValue, getValues, formState: { errors }, unregister } = useForm({
    defaultValues: { nombre: "", descripcion: "", monto: "" }
  });

  const [ProductosCompra, setProductosCompra] = useState([]);


  // Get data hijo
  const [datosCobro, setDatosCobro] = useState({
    pagos: [],
    productos: [],
    iva: 0,
    total: 0,
    totalPagado: 0,
    subtotal: 0,
    cambio: 0,
    faltante: 0,
    typeSale: 1
  });

  const handleUpdateCobro = (data) => {
    if (data.productos) {
      setProductosCompra(data.productos);
    }
    setDatosCobro(prev => ({ ...prev, ...data }));
    onUpdate?.(data); // <- notifica al padre
  };


  const addArticulo = (data) => {
    let sol = {
      "ID": Date.now(),
      "NOMBRE": data.nombre,
      "DESCRIPCION": data.descripcion,
      "COSTO_PUBLICO": data.monto,
      "costoHDL": data.costoHDL,
      "tecnico": data.tecnico,
      "EXISTENCIA": 1,
      "CANTIDAD": 1,
      "ACUMULADO": 1 * Number(data.monto),
      "VENTA_ESPECIAL": 1,
    }
    setProductosCompra([...ProductosCompra, sol]);
  }

  const clearForm = () => {
    reset();
    setProductosCompra([]);
  }

  return (
    <div className=' mt-2'>
      <form className='row' onSubmit={handleSubmit(addArticulo)} >
        <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 mb-3">
          <label className="form-label">Producto:</label>
          <input type="text" className={`form-control ${errors.nombre ? 'is-invalid' : ''}`} aria-describedby="emailHelp" autoComplete='off' {...register("nombre", { required: 'Nombre del articulo' })} />
          {
            errors.nombre &&
            <div className='text-left-5 mt-2'>
              <AlertTriangle size="18" color="#dc3545" />
              <span className='text-left-10 fw-bold text-danger'><small>{errors.nombre.message}</small></span>
            </div>
          }
        </div>

        <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 col-xxl-5 mb-3">
          <label className="form-label">Descripcion:</label>
          <input type="text" className="form-control" aria-describedby="emailHelp"{...register("descripcion")} />
        </div>

        <div className="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mb-3">
          <label className="form-label">Costo HDL:</label>
          <input type="number" className={`form-control ${errors.costoHDL ? 'is-invalid' : ''}`} step="any" aria-describedby="emailHelp" min={1} autoComplete='off' onKeyDown={InputValidators.validateDecimalKeyDown}
            {...register("costoHDL", { required: 'Costo del articulo', min: 1, onBlur: (e) => InputValidators.formatDecimalOnBlur_ReactHook(e, "costoHDL", setValue) })} />
          {
            errors.costoHDL &&
            <div className='text-left-5 mt-2'>
              <AlertTriangle size="18" color="#dc3545" />
              <span className='text-left-10 fw-bold text-danger'><small>{errors.costoHDL.message}</small></span>
            </div>
          }
        </div>

        <div className="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mb-3">
          <label className="form-label">Costo Cliente:</label>
          <input type="number" className={`form-control ${errors.monto ? 'is-invalid' : ''}`} step="any" aria-describedby="emailHelp" min={1} autoComplete='off' onKeyDown={InputValidators.validateDecimalKeyDown}
            {...register("monto", { required: 'Costo del articulo', min: 1, onBlur: (e) => InputValidators.formatDecimalOnBlur_ReactHook(e, "monto", setValue) })} />
          {
            errors.monto &&
            <div className='text-left-5 mt-2'>
              <AlertTriangle size="18" color="#dc3545" />
              <span className='text-left-10 fw-bold text-danger'><small>{errors.monto.message}</small></span>
            </div>
          }
        </div>
        <div className='col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8 mb-2'>
          <label className="form-label">Tecnico:</label>
          <select className="form-select " defaultValue={'0'}  {...register("tecnico")} >
            <option value={'0'} >Ninguno</option>
            {
              empleados.map((item, index) => (
                item.ESTADO == 1 && item.ROL_ID == 3 ? <option key={index} value={item.ID} className='text-uppercase' >({item.USER}) | {item.NOMBRE} </option>
                  : <option key={index} style={{ display: "none" }} ></option>
              ))
            }
          </select>
        </div>

        <div className="col-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 col-xxl-1 mb-3 mt-4">
          <div className="btn-group" role="group" aria-label="Basic example">
            <button type="button" className="btn btn-outline-danger mt-1" onClick={clearForm} ><Trash size='20' /></button>
            <button type="submit" className="btn btn-outline-dark mt-1" disabled={ProductosCompra.length != 0}   ><Plus size='20' /></button>
          </div>
        </div>


      </form >
      <div className='row'>
        <CardCobroVenta listProducts={ProductosCompra} listPaymentMethods={tipos_pagos} onUpdate={handleUpdateCobro} precioIncluyeIVA={true} />
      </div>
    </div>
  )
}
